package components.project.searchbar

import it.neckar.commons.kotlin.js.safeGet
import it.neckar.lizergy.model.project.previews.ResolvedProjectPreview
import it.neckar.logging.Logger
import it.neckar.logging.LoggerFactory
import it.neckar.react.common.*
import it.neckar.react.common.coroutines.*
import it.neckar.react.common.form.*
import kotlinx.coroutines.*
import kotlinx.coroutines.flow.*
import react.*
import react.dom.*
import services.http.ProjectSearchSupport

private val logger: Logger = LoggerFactory.getLogger("components.project.searchbar.ProjectSearch")


val ProjectSearch: FC<ProjectSearchProps> = fc("ProjectSearch") { props ->
  val navigateAction = props::selectProjectAction.safeGet()

  val coroutineScope = useCoroutineScope()
  val searchString = useState("")

  /**
   * Contains the found projects - from the server
   */
  val foundProjects = useState(emptyList<ResolvedProjectPreview>())


  //Create the project support once
  val projectSearchSupport = useMemo { ProjectSearchSupport() }

  useEffect {
    //Handle the search results
    coroutineScope.launch {
      projectSearchSupport.searchResults.collectLatest { result ->
        foundProjects.setter(result.projects)
      }

    }
  }

  FloatingInputField {
    attrs {
      value = searchString.value
      onChange = { newValue ->
        logger.debug("searchString changed to: ${searchString.value}")
        searchString.setter(newValue)
        projectSearchSupport.setSearchTerm(searchString.value)
      }
      fieldName = "projectSearch"
      title = "Projekt-Suche"
    }
  }

  div {
    ul("list-group") {
      foundProjects.value.forEach { projectPreview ->
        li("list-group-item") {
          +projectPreview.displayName

          attrs {
            onClick = {
              navigateAction(projectPreview)
            }
          }
        }
      }
    }
  }
}

external interface ProjectSearchProps : Props {
  /**
   * Is called if the user clicks on a project.
   * Usually navigates to the provided project.
   */
  var selectProjectAction: (project: ResolvedProjectPreview) -> Unit
}
